import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  specialLocationsOptionsArray,
  locationTypeOptionsArray,
  viaEmailChatBotOrOtherOptionsArray,
  smsOrEmailArray,
  smsChatWhatsappOptionsArray,
  surveyDistributionOptionsArray,
  bareOrClientSendArray,
  b2bOrB2cOptionsArray,
  bareOrClientSurveyArray,
  bareBrandedOptionsArray,
  inStoreOrOnlineOptionsArray,
  storeTypesArray,
  toolsArray,
  dataPointsArray,
  auditScheduleArray,
  operationalScopeArray,
  pricingAspectsArray,
  directedPricingArray,
  kpisBehaviorArray,
  tabletOrPaperOptionsArray,
  locationOrEntranceOptionsArray,
  monitoringTypeArray,
  platformsArray,
  frequencyArray,
  scopeArray,
  biToolArray,
  frequencyUpdateArray,
  dataSourcesArray,
  mainMetricsArray,
  visualizationsArray,
  interactiveFeaturesArray,
  templateArray,
  outputArray,
  mspPlatformArray,
  deliveryPlatformArray,
  reportingRequirementsArray,
  announcedOrUnannouncedArray,
  locationListSourceArray,
  timeConstraintsMaxLength,
} from './SharedConstants';

const coverageArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'FullInventory', label: 'Full inventory' },
  { value: 'SelectedCategories', label: 'Selected categories' },
  { value: 'Own', label: 'Own' },
  { value: 'Competitors', label: 'Competitors' },
  { value: 'Both', label: 'Both' },
  { value: 'Other', label: 'Other' },
];

const employeeReportingRequirementsArray = [
  { value: 'RawData', label: 'Raw Data' },
  { value: 'Dashboard', label: 'Dashboard' },
  { value: 'SummaryReport', label: 'Summary Report' },
];

const otherPages = [
  // ----------------------------------------------------------------
  // Fieldwork Requirements
  // Merged from: Audits, BareIfy, InPerson, Intercepts, InventoryAudits, OnlineWeb, Phone + Evaluation Duration + Data Capture Method
  // ----------------------------------------------------------------
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'InteractionRequired',
        label: 'Is Interaction Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ViaEmailChatBotOrOther',
        label: 'Via Email, Chat Bot, or Other?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: viaEmailChatBotOrOtherOptionsArray,
      },
      {
        fieldName: 'ProductOrServiceInquiry',
        label: 'Product or Service Inquiry?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TimeConstraints',
        label: 'Visit Time Constraints (days/hours/etc)',
        className: 'col-12',
        type: InputTypesEnum.Text,
        maxLength: timeConstraintsMaxLength,
      },
      {
        fieldName: 'EvaluationDuration',
        label: 'Evaluation Duration (minutes)',
        className: 'col-12',
        type: InputTypesEnum.IntToDateInputElement,
      },
      {
        fieldName: 'EstimatedTimePerAudit',
        label: 'Estimated Time per Audit (in minutes)',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'ChecklistDetails',
        label: 'Checklist Details',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'AuditSchedule',
        label: 'Audit Schedule',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(auditScheduleArray.map((a) => a.label)),
      },
      {
        fieldName: 'MaxDeliveryAfterShop',
        label: 'Time to Deliver Evaluation to Client',
        className: 'col-12',
        type: InputTypesEnum.MaxDeliveryAfterShop,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'EvaluatorRotation',
        label: 'Evaluator Rotation',
        className: 'col-12',
        type: InputTypesEnum.EvaluatorRotation,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OperationalScope',
        label: 'Operational Scope',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(operationalScopeArray.map((o) => o.label)),
      },
      {
        fieldName: 'UserRoles',
        label: 'User Roles',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'LocationsDeliveredByClient',
        label: 'Locations Delivered by Client',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'SpecialLocations',
        label: 'Select Special Locations if Applicable',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: specialLocationsOptionsArray,
      },
      {
        fieldName: 'LocationType',
        label: 'Location Type (select all that apply)',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: locationTypeOptionsArray,
      },
      {
        fieldName: 'LocationTypeDetails',
        label: 'Location Type Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.LocationType || !item.LocationType.includes('Other'),
      },
      {
        fieldName: 'LocationListProvided',
        label: 'Location List Provided',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'LocationListSource',
        label: 'If not provided, to be searched or BARE creates location list:',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationListSourceArray.map((l) => l.label)),
        hide: (item) => item.LocationListProvided == 'true' || item.LocationListProvided == '',
      },
      {
        fieldName: 'TypeOfStores',
        label: 'Type of Stores',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: storeTypesArray,
      },
      {
        fieldName: 'AnnouncedOrUnannounced',
        label: 'Announced or Unannounced?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(announcedOrUnannouncedArray.map((a) => a.label)),
      },
      {
        fieldName: 'LetterOfAuthorizationRequired',
        label: 'Letter of Authorization Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CallingAheadRequired',
        label: 'Calling Ahead of Audit Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhotosReqd',
        label: 'Photos Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhotosDescription',
        label: 'Please describe photos needed',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PhotosReqd !== 'true',
      },
      {
        fieldName: 'Tools',
        label: 'Tools',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: toolsArray,
      },
      {
        fieldName: 'DataPoints',
        label: 'Data Points',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(dataPointsArray.map((d) => d.label)),
      },
    ],
  },
  // ----------------------------------------------------------------
  // Program Approach
  // Merged from: Audits, CustomerSatisfaction, EmployeeSurvey, Intercepts, OnlineReputation, OnlineWeb, Phone
  // ----------------------------------------------------------------
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'InStoreOrOnline',
        label: 'In Store or Online',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: inStoreOrOnlineOptionsArray,
      },
      {
        fieldName: 'NumLocations',
        label: 'Number of Locations',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumItemsPricesPerLocation',
        label: 'Number of Items/Prices per Location?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumDaysInField',
        label: 'Number of Days in Field?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'B2borB2c',
        label: 'B2B or B2C?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: b2bOrB2cOptionsArray,
      },
      {
        fieldName: 'Objective',
        label: 'Objective',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Frequency',
        label: 'Frequency',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'Coverage',
        label: 'Coverage',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(coverageArray.map((c) => c.label)),
      },
      {
        fieldName: 'PricingAspectsToEvaluate',
        label: 'What pricing aspects should be evaluated?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: pricingAspectsArray,
      },
      {
        fieldName: 'ProductType',
        label: 'Product Type',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'DirectedPricingApproach',
        label: 'Directed price gathering, category scanning, full store scanning, or other',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: directedPricingArray,
      },
      {
        fieldName: 'DirectedPricingApproachDetails',
        label: 'Other Directed Pricing Approach Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.DirectedPricingApproach || !item.DirectedPricingApproach.includes('Other'),
      },
      {
        fieldName: 'DescriptionGatheringRequired',
        label: 'Description Gathering Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'KpisBehaviorRequirements',
        label: "Any specific KPI's or behavior requirement?",
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: kpisBehaviorArray,
      },
      {
        fieldName: 'PriceAccuracySlarequired',
        label: 'Price Accuracy SLA Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PriceAccuracySladescription',
        label: 'If yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PriceAccuracySlarequired == 'false' || item.PriceAccuracySlarequired == '',
      },
      {
        fieldName: 'CompetitorPricingStudy',
        label: 'Competitor Pricing Study?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumCompetitors',
        label: 'If yes, number of competitors',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.CompetitorPricingStudy == 'false' || item.CompetitorPricingStudy == '',
      },
      {
        fieldName: 'UpcjanianscanRequired',
        label: 'UPC/JAN/IAN Scan Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'DistributionOfSurvey',
        label: 'Distribution of Survey',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: surveyDistributionOptionsArray,
      },
      {
        fieldName: 'BareOrClientSend',
        label: 'Does BARE send or does the Client send?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareOrClientSendArray.map((b) => b.label)),
      },
      {
        fieldName: 'SmsorEmailForBare',
        label: 'If BARE sends, SMS or Email?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(smsOrEmailArray.map((s) => s.label)),
        hide: (item) => item.BareOrClientSend !== 'BARE send',
      },
      {
        fieldName: 'FrequencyOfSurvey',
        label: 'Frequency of Survey?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TargetNumResponses',
        label: 'Target Number of Responses?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'TargetAudience',
        label: 'Target Audience (Location, Gender, Age, Profession, Income, Other)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'IncentivesDescription',
        label: 'Incentives (please describe)?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'DurationOfSurvey',
        label: 'Duration of Survey',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'PreferredTimeline',
        label: 'Preferred timeline of starting and receiving the results',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'BareBrandedOrCompanyBranded',
        label: 'Bare Branded or Company Branded?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareBrandedOptionsArray.map((b) => b.label)),
      },
      {
        fieldName: 'EmployeesEnterName',
        label: 'Do employees enter their name?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ReportingRequirements',
        label: 'Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: employeeReportingRequirementsArray,
      },
      {
        fieldName: 'NumResponsesRequested',
        label: 'Number of Responses Requested',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumInterviewersPerLocation',
        label: 'Number of Interviewers per Location',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'LengthOfSurvey',
        label: 'Length of Survey',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'TabletOrPaper',
        label: 'Tablet or Paper?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(tabletOrPaperOptionsArray.map((t) => t.label)),
      },
      {
        fieldName: 'InLocationOrEntrance',
        label: 'In the location/store or entrance?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationOrEntranceOptionsArray.map((l) => l.label)),
      },
      {
        fieldName: 'AuthorizationLetterProvided',
        label: 'Authorization Letter Provided?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IncentiveCoordinationDescription',
        label: "If there are incentives, how will IC's coordinate incentive distribution?",
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'IccoordinatorBilingualRequired',
        label: 'Does IC Coordinator need to be bilingual?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BareOrClientSurvey',
        label: 'BARE provides survey or Client provides survey',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareOrClientSurveyArray.map((b) => b.label)),
      },
      {
        fieldName: 'IncentiveProvidedByBare',
        label: 'Incentive Provided by BARE?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'MonitoringType',
        label: 'Online Monitoring or Online Reputation Management?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(monitoringTypeArray.map((m) => m.label)),
      },
      {
        fieldName: 'PlatformsToMonitor',
        label: 'Media/Internet Platforms',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: platformsArray,
      },
      {
        fieldName: 'FrequencyOfMonitoring',
        label: 'Frequency of Monitoring',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(frequencyArray.map((f) => f.label)),
      },
      {
        fieldName: 'LanguagesToMonitor',
        label: 'Languages to Monitor',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'Keywords',
        label: 'Keywords',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GoalOfProgram',
        label: 'Goal of the Program',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'ScopeOfMonitoring',
        label: 'Scope of Monitoring',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: scopeArray,
      },
      {
        fieldName: 'ClientGuidelines',
        label: 'Client Guidelines',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  // ----------------------------------------------------------------
  // B2B Approach
  // From: OnlineWeb, Phone
  // ----------------------------------------------------------------
  {
    label: 'B2B Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'FictiosWebsiteCreationNeeded',
        label: 'Fictious Website Creation Needed',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IsBusinessInformationRequired',
        label: 'Is Business Information Required',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BusinessInformationDescription',
        label: 'If Yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Questionnaire
  // Merged from: BareIfy (Audit Survey), BI (Questionnaire), CustSat (Survey),
  //   EmployeeSurvey (Survey), InPerson (Questionnaire), Intercepts (Survey),
  //   OnlineWeb (Questionnaire), Phone (Questionnaire)
  // ----------------------------------------------------------------
  {
    label: 'Questionnaire',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'NumAuditSurveys',
        label: 'No. of Audit Surveys (Area to audit)',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'ApproxNumQuestionsPerSurvey',
        label: 'Approx. No. of Questions per Survey',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CollaborationInDataSoftware',
        label: 'Will Collaboration be used in Data Software?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'Mspplatform',
        label: 'MSP Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(mspPlatformArray.map((m) => m.label)),
        hide: (item) => item.CollaborationInDataSoftware !== 'true',
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TranslationProvided',
        label: 'Translation of Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'RequiredLanguageCode',
        label: 'Required Language(s) Reporting',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'TypeOfServiceRequested',
        label: 'Please choose the type of service you request',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Regularity',
        label: 'Regularity',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'SpecificRequirements',
        label: 'Please enter here specific requirements (e.g., live presentation, special score tier definition)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TopIssues',
        label:
          'Top issues that are concerning you/client at the moment and should be addressed in the report/analysis?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Demographics
  // Merged from: Audits (Auditor Demographics), InPerson (Evaluator Demographics),
  //   Intercepts (Target Audience Demographics), CustSat (Target Audience),
  //   OnlineWeb (B2C Demographics), Phone (B2C Demographics)
  // ----------------------------------------------------------------
  {
    label: 'Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'MaritalStatusCode',
        label: 'Marital Status',
        className: 'col-12',
        type: InputTypesEnum.CommonMaritalStatusLookupItemSelect,
      },
      {
        fieldName: 'IsChildRequiredForVisit',
        label: 'Child Required for Visit',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'EvaluationType',
        label: 'Description of additional Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.EvaluationTypeLookupItemSelect,
      },
      {
        fieldName: 'OtherDemographicRequirements',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Purchase
  // Merged from: Audits, InPerson, OnlineWeb, Phone
  // ----------------------------------------------------------------
  {
    label: 'Purchase',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'PurchaseReqd',
        label: 'Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ReceiptReqd',
        label: 'Receipt Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseAmtCurId',
        label: 'Purchase Amount Currency',
        className: 'col-12',
        type: InputTypesEnum.ActiveCurrencySelect,
      },
      {
        fieldName: 'PurchaseAmt',
        label: 'Minimum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxPurchaseAmt',
        label: 'Maximum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PurchaseDesc',
        label: 'Item Required to Be Purchased',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'PurchaseReimbursed',
        label: 'Purchase Reimbursed by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseIncluded',
        label: 'Purchase NOT Reimbursed by BARE or Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseReturned',
        label: 'Required Purchase to be returned by Evaluator as part of their Assignment Scenario?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhonePurchaseRequired',
        label: 'Over the Phone Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ReimbursementRequired',
        label: 'Reimbursement Requirement?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Validation
  // Merged from: Audits (Visit Validation), InPerson (Visit Validation, Video Visit Validation),
  //   OnlineWeb (Shop Validation), Phone (Shop Validation)
  // ----------------------------------------------------------------
  {
    label: 'Validation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'NumPhotographsReqd',
        label: 'Number of Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PhotosReqd',
        label: 'Storefront Photo Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'LeftRightLocReqd',
        label: 'Left and Right of Storefront Photos Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'OtherPhotosDesc',
        label: 'Describe other Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'SoundRecordingReqd',
        label: 'Sound Recording Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'OtherValidationReqd',
        label: 'Other Validation',
        className: 'col-12',
        type: InputTypesEnum.OtherValidationRequirementLookupItemSelect,
      },
      {
        fieldName: 'VideoValidationReqd',
        label: 'Video Validation Required',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumScreenshotsRequired',
        label: 'Number of Screenshots Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'SmsweChatWhatsappScreenshots',
        label: 'SMS, We Chat, or WhatsApp Screenshots Required?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: smsChatWhatsappOptionsArray,
      },
      {
        fieldName: 'VoicemailTimeStampScreenshot',
        label: 'Voicemail Time Stamp Screenshot',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumCallAttemptsPerEval',
        label: 'No. of Call Attempts per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Reporting Requirements
  // Merged from: BareIfy, InPerson, BusinessIntelligence, OnlineReputation
  // ----------------------------------------------------------------
  {
    label: 'Reporting Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'ReportingRequirements',
        label: 'Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: reportingRequirementsArray,
      },
      {
        fieldName: 'DetailedReportingRequirements',
        label: 'Detailed Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.ReportingRequirements || !item.ReportingRequirements.includes('Other'),
      },
      {
        fieldName: 'CustomExportsRequired',
        label: 'Custom Exports Required?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Apirequirement',
        label: 'API Requirement?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BitoolSelection',
        label: 'BI Tool Selection',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biToolArray.map((b) => b.label)),
      },
      {
        fieldName: 'FrequencyOfUpdate',
        label: 'Frequency of Update',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(frequencyUpdateArray.map((f) => f.label)),
      },
      {
        fieldName: 'DataSourcesOtherThanMs',
        label: 'Data Sources Other Than MS',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(dataSourcesArray.map((d) => d.label)),
      },
      {
        fieldName: 'MainMetrics',
        label: 'Main Metrics',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(mainMetricsArray.map((m) => m.label)),
      },
      {
        fieldName: 'ComparisonsByWaveAndRegion',
        label: 'Comparisons by Wave and Region',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'AdditionalVisualizations',
        label: 'Additional Visualizations',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: visualizationsArray,
      },
      {
        fieldName: 'InsightHighlights',
        label: 'Insight Highlights',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'InteractiveFeatures',
        label: 'Interactive Features',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: interactiveFeaturesArray,
      },
      {
        fieldName: 'SubDashboards',
        label: 'Sub Dashboards',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'UserAccess',
        label: 'User Access',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
    ],
  },
  // ----------------------------------------------------------------
  // Phone Call Requirements
  // From: InPerson
  // ----------------------------------------------------------------
  {
    label: 'Phone Call Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'PhoneCallsRequired',
        label: 'Are Phone Calls Required for In-Person Visit',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CallFlowDescription',
        label: 'If yes, please explain call flow',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PhoneCallsRequired == 'false' || item.PhoneCallsRequired == '',
      },
      {
        fieldName: 'CallerIdNeeded',
        label: 'Caller ID Needed?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhoneCallDescription',
        label: 'Description of Calls',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'NumCallsRecorded',
        label: 'No. of Recorded Calls per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'AvgVocazillaCallLength',
        label: 'Avg. Recorded Call Length (min) per Call',
        className: 'col-12',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces,
      },
      {
        fieldName: 'FollowUpPeriodExpected',
        label: 'Wait for Follow-up period expected before/after the call',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'NumCallsNonRecorded',
        label: 'No. of Non-Recorded Calls per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'AvgNonRecordedCallLength',
        label: 'Avg. Non-Recorded Call Length (min) per Call',
        className: 'col-12',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces,
      },
    ],
  },
  // ----------------------------------------------------------------
  // BI Analysis
  // From: BusinessIntelligence (BI Analysis + BI Consultancy)
  // ----------------------------------------------------------------
  {
    label: 'BI Analysis',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'Template',
        label: 'Template',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(templateArray.map((t) => t.label)),
      },
      {
        fieldName: 'Output',
        label: 'Output',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(outputArray.map((o) => o.label)),
      },
      {
        fieldName: 'NumVisualizations',
        label: 'Number of Visualizations (slides)',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ActionableInsights',
        label: 'Actionable Insights',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Kpianalysis',
        label: 'KPI Analysis',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'BenchmarkingAgainstIndustry',
        label: 'Benchmarking Against Industry',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'SourcesTypeOfPrograms',
        label: 'Sources / Type of Programs',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'ComparisonsByWave',
        label: 'Comparisons by Wave',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'ComparisonsByRegion',
        label: 'Comparisons by Region',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'BiconsultancyDescription',
        label: 'Please describe what BI will consult on (Data Software consultation)',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  // ----------------------------------------------------------------
  // BI Analysis
  // From: BusinessIntelligence
  // ----------------------------------------------------------------
  {
    label: 'BI Analysis',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Other,
    fields: [
      {
        fieldName: 'NumOpenEndsAnalyzed',
        label: 'Number of Open Ends to Be Analyzed',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumEvalPerCycle',
        label: 'Number of Evaluations per Cycle',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'Summarization',
        label: 'Summarization?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TopicModeling',
        label: 'Topic Modeling?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'EmotionAnalytics',
        label: 'Emotion Analytics?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'AspectBasedSentimentAnalysis',
        label: 'Aspect-Based Sentiment Analysis?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Mspplatform',
        label: 'MSP Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(mspPlatformArray.map((m) => m.label)),
      },
      {
        fieldName: 'DeliveryPlatform',
        label: 'Delivery Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(deliveryPlatformArray.map((d) => d.label)),
      },
    ],
  },
];

export default otherPages;
